import impostazioni from "../../cofig";
import http from "./controllerFetch";

const api_url = impostazioni.api_url;
class pdfService {
  
    getPdfPrezzi( params = {}) {
        return http.get(api_url + 'pdf/readPdf', {
            params: params,
            responseType: 'arraybuffer',
            headers: {
            'Accept': 'application/pdf'
            }
        })
    }
    getPdfPrezziNoPrezzi( params = {}) {
        return http.get(api_url + 'pdf/readPdfNoPrezzi', {
            params: params,
            responseType: 'arraybuffer',
            headers: {
            'Accept': 'application/pdf'
            }
        })
    }
    rigeneraPdf( params = {}) {
        return http.get(api_url + 'pdf/rigeneraPdf', {
            params: params
        })
    }
  
  
  
  }
  
  export default new pdfService();